export default __webpack_public_path__ + "static/media/feature-project-mgt-3.b9f8279b.png";